module.exports = __webpack_public_path__ + "img/solution_4.c91f9636.png";